import { Request } from '../../Servidor/Request';

export class VectorQuantificationRelatoryInteractor {
    public fetchVectorQuantification(filters: Array<any>): PromiseLike<any> {
        return new Promise((res, rej) => {
            return new Request().requestPost("relatorio/quantificacao-vetores", { ...filters }).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchVectorQuantificationRelatory(filters: Array<any>): PromiseLike<any> {
        let name = 'Quantificação_vetores.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/quantificacao-vetores-pdf", { ...filters }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}